import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Client, CreateClientDto, UpdateClientDto } from '../../models/forwarding/client.model';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  private apiUrl = `${environment.apiUrl}/forwarding/clients`;
  private clientsSubject = new BehaviorSubject<Client[]>([]);
  public clients$ = this.clientsSubject.asObservable();

  constructor(private http: HttpClient) {
    this.loadClients();
  }

  private loadClients(): void {
    console.log('[ClientService] Loading clients from:', this.apiUrl);
    this.http.get<Client[]>(this.apiUrl).subscribe({
      next: (clients) => {
        console.log('[ClientService] Successfully loaded clients from API:', clients.length, clients);
        this.clientsSubject.next(clients);
      },
      error: (error) => {
        console.error('[ClientService] Error loading clients from API:', error);
        this.clientsSubject.next([]);
      }
    });
  }

  getClients(): Observable<Client[]> {
    return this.clients$;
  }

  getById(id: number): Observable<Client> {
    return this.http.get<Client>(`${this.apiUrl}/${id}`);
  }

  create(dto: CreateClientDto): Observable<Client> {
    return this.http.post<Client>(this.apiUrl, dto).pipe(
      tap(() => {
        console.log('[ClientService] Client created, reloading clients');
        this.loadClients();
      })
    );
  }

  update(id: number, dto: UpdateClientDto): Observable<Client> {
    return this.http.put<Client>(`${this.apiUrl}/${id}`, dto).pipe(
      tap(() => {
        console.log('[ClientService] Client updated, reloading clients');
        this.loadClients();
      })
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`).pipe(
      tap(() => {
        console.log('[ClientService] Client deleted, reloading clients');
        this.loadClients();
      })
    );
  }
}
